var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9562 15.2938C16.0023 15.3367 16.0392 15.3884 16.0649 15.4459C16.0905 15.5034 16.1043 15.5655 16.1054 15.6285C16.1065 15.6914 16.0949 15.7539 16.0713 15.8123C16.0477 15.8706 16.0127 15.9237 15.9681 15.9682C15.9236 16.0127 15.8706 16.0478 15.8122 16.0714C15.7539 16.0949 15.6914 16.1065 15.6284 16.1054C15.5655 16.1043 15.5034 16.0905 15.4459 16.0649C15.3884 16.0393 15.3367 16.0023 15.2937 15.9563L10 10.6633L4.70625 15.9563C4.61739 16.0391 4.49986 16.0842 4.37842 16.082C4.25698 16.0799 4.14112 16.0307 4.05523 15.9448C3.96935 15.8589 3.92015 15.743 3.91801 15.6216C3.91587 15.5002 3.96095 15.3826 4.04375 15.2938L9.33671 10L4.04375 4.70628C3.96095 4.61742 3.91587 4.49989 3.91801 4.37845C3.92015 4.25701 3.96935 4.14115 4.05523 4.05526C4.14112 3.96938 4.25698 3.92018 4.37842 3.91804C4.49986 3.9159 4.61739 3.96098 4.70625 4.04378L10 9.33675L15.2937 4.04378C15.3826 3.96098 15.5001 3.9159 15.6216 3.91804C15.743 3.92018 15.8589 3.96938 15.9448 4.05526C16.0306 4.14115 16.0798 4.25701 16.082 4.37845C16.0841 4.49989 16.039 4.61742 15.9562 4.70628L10.6633 10L15.9562 15.2938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconWhite);
export default __webpack_public_path__ + "static/media/x-icon-white.ae6a176245e4a7b874253112cb1ce3a3.svg";
export { ForwardRef as ReactComponent };